<div class="modal-body">
  <p class="centermodal__title centermodal__title--red">{{ 'documents.insufficientCredits' | translate }}</p>
  <img width="281" style="margin: 0 auto; display: block" [src]="'assets/alerts/warning.svg'" class="centermodal__img" />

  <div class="centermodal__message-body centermodal__message-body--margin-normal">
    <p class="centermodal__message" [innerHTML]="'documents.insufficientCreditsMessage' | translate"></p>
  </div>

  <div class="centermodal__message-body centermodal__message-body--margin-normal">
    <p class="centermodal__message">
      <span>{{ 'documents.whatIsThis' | translate }}</span
      ><br />
      {{ 'documents.additionalCreditsExplanation' | translate }}
    </p>
  </div>

  <div class="centermodal__message-body centermodal__message-body--margin-normal">
    <p class="centermodal__message" *ngIf="!isChildOrganization()">
      <span>{{ 'documents.needToPurchaseMore' | translate }}</span
      ><br />
      {{ 'documents.purchaseCreditsMessage' | translate }}
    </p>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.cancel' | translate }}</button>
    <button type="button" class="btn-M btn-filled" [disabled]="isLoading" (click)="goToPayment()" *ngIf="!isChildOrganization()">
      {{ 'documents.checkPackages' | translate }}
    </button>
  </div>
</div>
